module.exports = {
  popup_hints: {
    dashboard_list: 'Открыть список рабочих столов',
    dashboard_intervals: 'Задать временной период для всех диаграмм',
    grid_layout_settings: 'Изменить размер и расположение графиков',
  },
  system: {
    not_owner_only: 'Виден всем пользователям',
    owner_only: 'Виден только владельцу',
    add_new_dashboard: 'Добавить рабочий стол',
    new_dashboard_system_name: 'Рабочий стол %{name}',
    dashboard_empty: 'На рабочем столе нет графиков',
    access_change_owner: 'Разрешить смену владельца',
  },
  buttons: {
    add_new_graph: 'Добавить график',
    add_dashboard: 'Добавить рабочий стол',
    be_owner: 'Стать владельцем рабочего стола',
  },
  modals: {
    editModal: {
      choose_interval: 'Выбор периода по умолчанию',
      warning_text:
        'Выбранный период будет сохранен и действовать на график вне зависимости от настроенного периода графика в отчете, а также от выбранного периода на рабочем столе.',
      save_chart_settings: 'Сохранить',
      add_chart: 'Добавить',
    },
    create_chart_modal: {
      title: 'Добавить график из отчета',
      create: 'Создать',
      reset: 'Сбросить',
    },
    delete_modal: {
      main_text: 'Вы действительно хотите удалить данный рабочий стол?',
    },
  },
  widget: {
    widget_settings_label: 'Настройки виджета',
    menu: 'Меню',
    edit_widget: 'Редактировать виджет',
    configure_widget: 'Настроить виджет',
    clone_widget: 'Клонировать виджет',
    delete_widget: 'Удалить виджет',
    form_fields: {
      name: 'Название виджета',
      description: 'Описание',
      color: 'Цвет виджета',
      label_font_size: 'Размер шрифта заголовка',
      label_color: 'Цвет заголовка',
      main_chart: 'Основной график',
      conditional_formatting: 'Условное форматирование',
      comment: 'Комментарий',
      comment_text: 'Текст',
      comment_font_size: 'Размер шрифта',
      comment_color: 'Цвет',
      range: 'Период по умолчанию',
      range_interval_from: 'от',
      range_interval_to: 'до',
    },
    save_button: 'Сохранить',
    close_button: 'Отмена',
    reset_button: 'Сбросить',
    delete_button: 'Удалить',
    reset_selected: 'Снять выделение',
    remove_widget_description: 'Удалить виджет ?',
    your_sure: 'Все элементы виджета исчезнут',
  },
};
